import { render } from "./RadiologyManagement.vue?vue&type=template&id=3f4336ae&scoped=true"
import script from "./RadiologyManagement.vue?vue&type=script&lang=js"
export * from "./RadiologyManagement.vue?vue&type=script&lang=js"

import "./RadiologyManagement.vue?vue&type=style&index=0&id=3f4336ae&lang=css"
import "./RadiologyManagement.vue?vue&type=style&index=1&id=3f4336ae&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4336ae"]])

export default __exports__